import HlpBranches from "components/HelpSlides/InEffice/HlpBranches";
import HelperTip from "components/HOCS/HelperTip";
import InvitePeopleIcon from "graphics/icons/BranchBar/InvitePeopleIcon";
import { iAmAdmin } from "helpers/efficeHelpers";
import { FM_BRANCHES } from "helpers/freshman";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentActive,
  selectCurrentRoot,
  selectCurrentTree,
  selectDepth,
} from "slices/efficeTreeSlice";
import { selectCurrentRootEffice } from "slices/sharedSelectors";
import { setAddPeopleModal } from "slices/textSlice";
import Branch from "./Branch/Branch";

const BranchBar = () => {
  const dispatch = useDispatch();
  const currentRoot = useSelector(selectCurrentRoot);
  const currentActive = useSelector(selectCurrentActive);
  const currentTree = useSelector(selectCurrentTree);
  const totalDepth = useSelector(selectDepth);
  const amAdminOfRoot = iAmAdmin(useSelector(selectCurrentRootEffice));

  if (!currentActive) return null;
  return (
    <HelperTip
      code={FM_BRANCHES}
      placement="right-start"
      component={<HlpBranches />}
      style={{ width: "560px" }}
      lazy
    >
      <div
        className={`branch-bar-no-overflow ${
          amAdminOfRoot ? "admin-root" : ""
        }`}
      >
        <div className="branch-bar">
          <div className="scroll-wrapper">
            <Branch
              id={currentRoot}
              key={currentRoot}
              totalDepth={totalDepth}
              currentDepth={1}
              tree={currentTree[currentRoot]}
            />
          </div>
        </div>
        {amAdminOfRoot && (
          <button
            className="side-invite-to-effice"
            onClick={() => dispatch(setAddPeopleModal(currentRoot))}
          >
            <InvitePeopleIcon /> Add Official Members
          </button>
        )}
      </div>
    </HelperTip>
  );
};

export default BranchBar;
